module.exports = __webpack_public_path__ + "static/favicon-4bd70821ef6cedc50036b87f0e1c5b46.ico";